module.exports = "<app-settings></app-settings>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/remote/remote.component.html
// module id = ./src/app/remote/remote.component.html
// module chunks = main